import classes from './Menu.module.css';

export const MenuOverrideClassNames = () => {
  return {
    dropdown: classes.dropdown,
    item: classes.item
  };
};
